import { Modal, Flex, message } from "antd";
import { CustomTitle } from "../../components";
import mail from "../../assets/images/mailFilled.svg";
import emailAvatar from "../../assets/images/emailAvatar.svg";
import userAvatar from "../../assets/images/userAvatar.svg";
import { useEffect, useState } from "react";
import { useSpin } from "../../components/SpinContext";
import { getEmailTranscript } from "../../api's/shipment";
import { formatToCDT } from "./AiTranscriptModal";
import ToggleSwitch from "../../components/ToggleSwitch";

const AiEmailExchangeModal = ({ open, onClose, alert, token, unauthorize,shipment }) => {
  const { showSpin, hideSpin } = useSpin();
  const [transcriptData, setTranscriptData] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    if (!alert?.id) return;
    showSpin();
    getEmailTranscript(token, alert.id,!isChecked?'English':shipment?.tp_primary_contact?.preferred_language)
      .then((res) => {
        const data = res?.data || null;
        if (data?.data?.is_success) {
          setTranscriptData(data.data.data);
        } else {
          message.error(data?.data?.message);
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  }, [alert, token,isChecked]);


  // Function to handle the toggle action
  const handleToggle = (e) => {
    setIsChecked(e.target.checked);
    const val = e.target.checked;
    // fetchAllUsers(val);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={700}
      closeIcon
    >
      <Flex align="center" gap="8px" style={{ marginBottom: "8px" }}>
        <img src={mail} alt="icon" width={20} height={20} />
        <CustomTitle
          text="AI email exchange"
          fontSize="20px"
          lineHeight="28px"
          fontWeight="700"
          marginBottom="0"
        />
      </Flex>

      <p
        style={{
          fontSize: "12px",
          lineHeight: "20px",
          color: "#000",
          marginBottom: "8px",
        }}
      >
        <span style={{ fontWeight: 600 }}>Summary:</span>{" "}
        {transcriptData?.summary || "No summary provided."}
      </p>
      <CustomTitle
        text={`Message is a translation to recipient’s preferred language of ${
          transcriptData?.company_courier_preferred_language || "English(US)"
        }.`}
        fontSize="12px"
        lineHeight="20px"
        fontWeight="400"
        marginBottom="16px"
      />

      {/* Message Thread */}
      <div
        className="email-thread-scroll"
        style={{
          background: "#F6F6F6",
          padding: "16px",
          borderRadius: "12px",
          maxHeight: "480px",
          overflowY: "auto",
        }}
      >
        {(transcriptData?.transcript || []).map((msg, index) => {
          const isCompany = msg.sender === "AI";

          return (
            <div
              key={index}
              style={{
                padding: "16px",
                background: "#fff",
                borderRadius: "8px",
                marginBottom: "12px",
                position: "relative",
              }}
            >
              <Flex justify="space-between" align="start">
                <Flex gap="12px" align="start">
                  <img
                    src={isCompany ? emailAvatar : userAvatar}
                    width={32}
                    alt="avatar"
                  />
                  <div>
                    <p
                      style={{
                        marginBottom: "4px",
                        fontSize: "12px",
                        fontWeight: isCompany ? 600 : 500,
                      }}
                    >
                      {msg.sender}{" "}
                      <span style={{ fontWeight: 400 }}>{`<${msg.from}>`}</span>
                    </p>
                    <p
                      style={{
                        color: "#4B4B4B",
                        fontSize: "10px",
                        marginBottom: "12px",
                      }}
                    >
                      to {msg.to}
                    </p>
                    <p
                      style={{
                        fontSize: "12px",
                        whiteSpace: "pre-wrap",
                        fontWeight: 400,
                        marginBottom: "0",
                      }}
                    >
                      {msg.body}
                    </p>
                  </div>
                </Flex>
                <span
                  style={{
                    fontSize: "10px",
                    color: "#4B4B4B",
                    whiteSpace: "nowrap",
                    marginTop: "4px",
                  }}
                >
                  {formatToCDT(msg.timestamp)}
                </span>
              </Flex>
            </div>
          );
        })}
      </div>

      <Flex style={{ alignItems: "center", gap: "8px", marginTop: "16px", marginLeft:'-4px' }}>
        <ToggleSwitch label="" checked={isChecked} onChange={handleToggle} />
        <CustomTitle
          text={`Show in your preferred language: ${transcriptData?.company_user_preferred_language || 'English(US)' } `}
          fontSize="12px"
          lineHeight="16px"
          fontWeight="600"
          marginBottom="0"
        />
      </Flex>
    </Modal>
  );
};

export default AiEmailExchangeModal;
